export default "__VITE_ASSET__C9djCM3P__"